import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';

import { selectTeamChatActiveChannelId } from 'store/teamChat/selectors';

import { maybeFireBrowserNotification, maybePlaySound } from './utils';

const useTeamChatNotificationsDispatcher = ({ loggedUserId }) => {
  const activeChatId = useSelector(selectTeamChatActiveChannelId);
  const activeChatIdRef = useRef(activeChatId);
  const loggedUserIdRef = useRef(loggedUserId);
  const audioContextRef = useRef();

  useEffect(() => {
    activeChatIdRef.current = activeChatId;
  }, [activeChatId]);

  useEffect(() => {
    loggedUserIdRef.current = loggedUserId;
  }, [loggedUserId]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return _.noop;
    }

    const onMessageReceived = e => {
      const detail = e?.detail;

      if (!detail) {
        return;
      }

      maybeFireBrowserNotification({
        detail,
        loggedUserId: loggedUserIdRef.current,
        activeChatId: activeChatIdRef.current,
      });

      maybePlaySound({
        detail,
        loggedUserId: loggedUserIdRef.current,
        activeChatId: activeChatIdRef.current,
        audioContextRef,
      });
    };

    window.addEventListener('teamchat:message-received', onMessageReceived);

    return () => {
      window.removeEventListener('teamchat:message-received', onMessageReceived);
    };
  }, []);
};

export default useTeamChatNotificationsDispatcher;
